import useGTM from "@elgorditosalsero/react-gtm-hook";

export const WALLET_CTA_VIEWED = "wallet_cta_viewed";
export const WALLET_ADD_ATTEMPTED = "wallet_add_attempted";
export const WALLET_ADD_SUCCEEDED = "wallet_add_succeeded";
export const WALLET_ADD_FAILED = "wallet_add_failed";

export interface WalletEventPayload {
  planType?: string;
  correlationId?: string;
}

export function useWalletAnalytics() {
  const { sendDataToGTM } = useGTM();

  return {
    trackWalletCtaViewed: (payload?: WalletEventPayload) =>
      sendDataToGTM({ event: WALLET_CTA_VIEWED, ...payload }),
    trackWalletAddAttempted: (payload?: WalletEventPayload) =>
      sendDataToGTM({ event: WALLET_ADD_ATTEMPTED, ...payload }),
    trackWalletAddSucceeded: (payload?: WalletEventPayload) =>
      sendDataToGTM({ event: WALLET_ADD_SUCCEEDED, ...payload }),
    trackWalletAddFailed: (payload?: WalletEventPayload) =>
      sendDataToGTM({ event: WALLET_ADD_FAILED, ...payload }),
  };
}
